import { create } from 'zustand';

export type Toast = {
  id: number;
  message: string;
  tone: 'error' | 'info';
};

type ToastStore = {
  toasts: Toast[];
  push(message: string, tone?: Toast['tone']): void;
  dismiss(id: number): void;
};

let nextId = 1;

export const useToasts = create<ToastStore>((set) => ({
  toasts: [],
  push(message, tone = 'error') {
    const id = nextId++;
    set((state) => ({ toasts: [...state.toasts, { id, message, tone }] }));
    setTimeout(() => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })), 5000);
  },
  dismiss(id) {
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));

export const toast = {
  error: (message: string) => useToasts.getState().push(message, 'error'),
  info: (message: string) => useToasts.getState().push(message, 'info'),
};
